// One explicit decision at a time. No mounted UI or duplicate dialog => cancel,
// never silently authorize spending. Nothing sensitive is persisted on disk.
let listener = null;
let pending = null;

export function subscribeAiConsent(show) {
    listener = show;
    return () => {
        if (listener === show) {
            listener = null;
            pending?.(false);
        }
    };
}

export function requestAiConsent(quote) {
    if (!listener || pending) return Promise.resolve(false);
    return new Promise(resolve => {
        const finish = accepted => {
            if (pending !== finish) return;
            pending = null;
            listener?.(null);
            resolve(accepted === true);
        };
        pending = finish;
        listener({ quote, finish });
    });
}
